import React from "react";

function Popup(props){
    return(props.trigger)?(
        <div className = "popup" onClick={()=>props.setTrigger(false)} >
            <div className="popup-inner">
                {props.children}
                <button className="mobileNavbarBtn" onClick={()=>props.setTrigger(false)} >
                Uždaryti
                </button>

            </div>

        </div>
    ) :"";
}

export default Popup